import React from 'react';
import { connect } from 'react-redux';
import { Button, Header, Icon, Image, Modal } from 'semantic-ui-react';

export default function ContextualMenu(props) {
  if (props.show) {
    // avoid page ficker
    document.body.classList.add('scrolling');
  }
  return (
    <Modal
      size={props.size || null}
      open={props.show}
      onClose={() => {
        if (props.hideWhenClickAway) {
          props.onClose();
        }
      }}
      className={props.className + ' scrolling'}
      closeOnDimmerClick={props.hideWhenClickAway}
      onMount={() => {
        if (props.isSingleColumnModal) {
          document.body.classList.add('single-column-modal-background', 'scrolling');
        }
        if (props.isNonTransparentBgModal) {
          document.body.classList.add('non-transparent-modal-background', 'scrolling');
        }
      }}
      onUnmount={() => {
        if (props.isSingleColumnModal) {
          document.body.classList.remove('single-column-modal-background');
        }
        if (props.isNonTransparentBgModal) {
          document.body.classList.remove('non-transparent-modal-background');
        }
      }}
    >
      {props.children}
    </Modal>
  );
}

//  <Modal show={this.props.show} hideWhenClickAway={this.props.hideWhenClickAway} className={this.state.updateOrInsert + '-group'}></Modal>
